import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import RouteComponent from "./routes";

import { getUser } from "./utils/common";
import { useNavigate } from "react-router-dom";

import { getUserProfile } from "./store/actions/user";
import * as Sentry from "@sentry/react";

Sentry.init({
  enabled: true,
  environment: process.env.NODE_ENV,
  enableSpotlight: process.env.NODE_ENV,
  tracesSampleRate: 0.1,
  dsn: "https://6c27a06776ff191bfce5e990aba2c22b@o4509122547679232.ingest.de.sentry.io/4509886227677264",
  sendDefaultPii: true,
  // replaysSessionSampleRate: 0.1,
  // replaysOnErrorSampleRate: 1,
  attachScreenshot: true,
});
const App = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (getUser()) {
      // dispatch(getUserProfile());
    } else {
      navigate("/");
    }
  }, []);
  if (process.env.NODE_ENV === "production") {
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
  }

  if (process.env.NODE_ENV === "production") {
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
  }

  return (
    <>
      <RouteComponent />
      {/* Single app-wide host for react-toastify; pages only call toast.* */}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        limit={5}
        style={{ zIndex: 100000 }}
      />
    </>
  );
};

export default App;
